import moment from 'moment';

/* Форматы вывода режима «Кафедры» (п. 14 ТЗ).
   Дата вкладок «Штат»/«МТС» приходит уже как ДД.ММ.ГГГГ, дата файла — как
   «dd/mm/yyyy HH:MM:SS»; ставка — строкой с точкой («1.00»); незаполненное — null.
   Приводит к виду для экрана клиент; ничего не пересчитывает. */

export const isEmpty = (value) => value == null || value === '';

// Дата — ДД.ММ.ГГГГ. Понимаем ISO, «dd/mm/yyyy HH:MM:SS» и уже готовый вид.
// Нераспознанное значение выводим как есть, а не «Invalid date».
export const formatDate = (value) => {
  if (isEmpty(value)) return null;
  const formats = ['YYYY-MM-DD', 'DD/MM/YYYY HH:mm:ss', 'DD/MM/YYYY', 'DD.MM.YYYY'];
  const date = moment(String(value), formats, true);
  return date.isValid() ? date.format('DD.MM.YYYY') : value;
};

// Ставка — два знака через запятую. Округлять нельзя: 0,50 доходит до экрана как есть.
export const formatRate = (value) => (isEmpty(value) ? null : String(value).replace('.', ','));

// Размер файла — Б / КБ / МБ, разделитель дробной части — запятая («1,2 МБ»).
export const formatSize = (bytes) => {
  const num = Number(bytes);
  if (!Number.isFinite(num) || num < 0) return null;
  if (num < 1024) return `${num} Б`;
  if (num < 1024 * 1024) return `${Math.round(num / 1024)} КБ`;
  return `${(num / (1024 * 1024)).toFixed(1).replace('.', ',')} МБ`;
};
